import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Vertical } from './models/vertical';

@Injectable()
export class VerticalService {
  private baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.baseUrl + 'verticals';
  }

  all(languageAbbreviation: string) {
    const params = new HttpParams().set('languageAbbreviation', languageAbbreviation);
    return this.http.get<Vertical[]>(`${this.baseUrl}`, { params: params });
  }
}
